import React, { useEffect, useRef, useState } from "react";
import "./styles.css"
import FilterCross from "./FilterCross";
import Link from "../../utils/link";

const titleMap = {
  "type-of-client-projects": "Type of Client",
  "type-of-work-projects": "Type of Work",
  "type-of-blog-journal": "Category"
}

const FilterCol = (props) => {

  // try get title map, otherwise use filter type

  const title = titleMap[props.title] || props.title

  if (title == undefined){
    return null
  }

  const hasFiltered = props.filters.filter((filter) => filter.selected).length > 0;

  

  return (
    <div className={`mt-2 lg:my-0 ${title == undefined ? `hidden` : ``} ${title == "Category" ? `text-base lg:text-lg lg:space-x-16` : ``} ${props.colCount == 1 ? `col-span-2 lg:flex space-y-4 lg:space-y-0 mb-5` : `space-y-4 mb-5`}`}>
      <h2 className={`uppercase filter-title empty:hidden ${title == "Category" ? `lg:!hidden` : ``} `}>
        {title}
      </h2>
      {
        title == "Category" ? (
          <button
          key={`all`}
          className={`filter-tag w-fit cursor-pointer transition-all !ml-0 hidden lg:inline-block  ${!hasFiltered ? "font-semibold filter-active" : ``} ${title == "Category" ? `uppercase text-lg` : ``} `}
          onClick={() => props.resetFilters()}
        >
          All
        </button>

        ) : null
      }
      <div className={`${props.colCount == 1 ? `grid-cols-2 lg:grid-cols-8` : `lg:grid-cols-4`} gap-2 ${title == "Category" ? `lg:space-x-16 mobile:grid` : `grid`} `}>
        {props.filters.map((filter) => (
          <button
            key={filter.id}
            className={`filter-tag w-fit cursor-pointer transition-all ${title == "Category" ? `lg:uppercase lg:text-lg` : ``} ${filter.selected ? "font-semibold filter-active" : ""
              }`}
            onClick={() => props.handleFilterSelect(filter.id)}
          >
            {filter.title}
          </button>
        ))}
      </div>
    </div>

  )
}

const FilterList = (props) => {


  const [isOpen, setIsOpen] = useState(false)

  const dropdownRef = useRef(null)

  const getMaxHeight = () => {
    if (typeof window === `undefined`) return `0px`

    if (window.innerWidth < 1024) {
      if (dropdownRef.current) {
        return isOpen ? `${dropdownRef.current.scrollHeight}px` : `0px`
      }
    }
    return `0px`
  }

  const handleFilterSelect = (id) => {
    const updatedFilters = props.filters.map((filter) => {
      if (filter.id === id) {
        return {
          ...filter,
          selected: !filter.selected
        };
      } else {
        return filter;
      }
    });
    props.setFilters(updatedFilters);
  };

  const col1Filters = props.filters.filter((filter) => filter.col === props.filterCols[0]);
  const col2Filters = props.filters.filter((filter) => filter.col === props.filterCols[1]);

  const colCount = col2Filters.length > 0 ? 2 : 1;

  return (
    <div>
      <button className={`text-sm lg:hidden w-full flex items-center justify-between filter-dropdown pb-[10px] ${isOpen ? `active` : ``}`} onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        title="Open filter dropdowns"
      >
        <span>
          Filter
        </span>

        <FilterCross />

      </button>
      <div className={`grid grid-cols-2 gap-10 lg:gap-6 text-xs lg:text-base ${props.filterCols[0] == "type-of-blog-journal" ? `lg:pb-4` : `lg:pb-6`} overflow-hidden transition-all duration-300 lg:!max-h-[100%]
      ${isOpen ? `opacity-100 ` : `max-h-0 opacity-0 lg:opacity-100`}
      `} ref={dropdownRef}
        style={{
          maxHeight: getMaxHeight()
        }}
      >



        <FilterCol title={props.filterCols[0]} filters={col1Filters} handleFilterSelect={handleFilterSelect} colCount={colCount} resetFilters={props.resetFilters} />
        <FilterCol title={props.filterCols[1]} filters={col2Filters} handleFilterSelect={handleFilterSelect} colCount={colCount} resetFilters={props.resetFilters} />
      </div>
    </div>
  );
};

export default FilterList;
